import { render, staticRenderFns } from "./deviceLanguageRule.vue?vue&type=template&id=49f568ba&scoped=true"
import script from "./deviceLanguageRule.vue?vue&type=script&lang=js"
export * from "./deviceLanguageRule.vue?vue&type=script&lang=js"
import style0 from "./deviceLanguageRule.vue?vue&type=style&index=0&id=49f568ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f568ba",
  null
  
)

export default component.exports